import React from 'react'
import Tareas from '../components/Tareas'

const tareas = () => {
  return (
    <Tareas />
  )
}

export default tareas